import React from "react";
import PropTypes from "prop-types";
import { AttackFramework } from "@ticore/metadata";
import { useNavigate } from "react-router-dom";
import { getSearchPivotLink } from "../../../../samples/util";
import TiCoreMetadataWrapper from "../../TiCoreMetadataWrapper";

const apiFields = "attack";

const MitreAttack = ({ hash = null }) => {
  const navigate = useNavigate();

  const responseTransformation = response => {
    const data = response?.attack[0] || [];
    return {
      attack: {
        [data.matrix]: data.tactics
      },
      iconTooltipText: "Look Up on Search",
      onTechniqueIdClick: string => {
        navigate(getSearchPivotLink(`attack-technique: "${string}"`));
      },
      useLatest: true
    };
  };

  return (
    <TiCoreMetadataWrapper
      sha1={hash}
      Component={AttackFramework}
      apiFields={apiFields}
      responseTransformation={responseTransformation}
    />
  );
};

MitreAttack.propTypes = {
  hash: PropTypes.string
};

export default MitreAttack;
